module.exports = __webpack_public_path__ + "static/media/mei_presval_titulo.83429a1e.svg";